import * as Yup from "yup";
import { COMPANY_BASE_PROPERTIES } from "../../../../api/constants";

export const mediamathConfig = {
  ...COMPANY_BASE_PROPERTIES,
  /**
   * User Readable name of company the user is onBoarding with
   */
  companyText: "Onboarding With MediaMath",

  /**
   * lowercase no spaces or underscores name of company
   * This will be passed to the activate model and
   * used when saving to create the correct submission url
   */
  company: "mediamath",

  /**
   * HTML that explains how to use the form
   */
  instructions:
    "<p>Please select the Start and End dates and provide at least one of the following: Organization ID, Advertiser ID, or Agency ID.</p>" +
    "Please note that MediaMath must first grant Semcasting permission to post segments to your MediaMath account.  To enable this access, you may contact your Semcasting Sales Representative or MediaMath Support directly.",


  /**
   * data used to create a company activation block
   */
  companyBlockOptions: {
    val: "mediamath",
    text: "MediaMath",
    img: "mediamath-logo.svg",
  },

  /**
   * anchor tag used to login to a specific platform
   */
  loginLink: "",

  layout: [
    {
      fieldType: "dateRange",
      fieldName: "campaign_range",
      labelText: "Campaign Date Range",
      required: "dateRangeRequired",
    },
    {
      fieldType: "savableFieldsWrapper",
      layout: [
        {
          fieldType: "searchSelect",
          fieldName: "organization_id",
          labelText: "Organization ID",
          url: "/v2/secure/attributor/activate-credentials/mediamath/organization_id",
          placeholder: "Select an Organization ID or add a new one",
          namePropName: "value",
          textPropName: "value",
          valuePropName: "id",
          required: false,
        },
        {
          fieldType: "searchSelect",
          fieldName: "agency_id",
          labelText: "Agency ID",
          url: "/v2/secure/attributor/activate-credentials/mediamath/agency_id",
          placeholder: "Select an Agency ID or add a new one",
          namePropName: "value",
          textPropName: "value",
          valuePropName: "id",
          required: false,
        },
        {
          fieldType: "searchSelect",
          fieldName: "advertiser_id",
          labelText: "Advertiser ID",
          url: "/v2/secure/attributor/activate-credentials/mediamath/advertiser_id",
          placeholder: "Select an Advertiser ID or add a new one",
          namePropName: "value",
          textPropName: "value",
          valuePropName: "id",
          required: false,
        },
        {
          fieldType: 'checkbox',
          fieldName: "save_credentials",
          labelText: 'Save Organization/Agency/Advertiser IDs for future use',
          checked: false,
        },
      ],
    },
    {
      fieldType: "radioGroup",
      labelText: "Planned Usage of this Segment:",
      fieldName: "audience_usage",
      required: true,
      radioButtons: [
        {
          labelText: "Targeting",
          fieldName: "use_type_inclusion",
          value: "I",
          checked: false,
        },
        {
          labelText: "Suppression",
          fieldName: "use_type_exclusion",
          value: "X",
          checked: false,
        },
      ],
    },
    {
      fieldType: "pricing",
    },
  ],

  /**
   * an array of property names that can be saved and repeatedly used to "Activate/OnBoard" with a specific company
   */
  savableDataNames: ["organization_id", "advertiser_id", "agency_id"],
  formik: {
    initialValues: {
      device_type: ["ios_android"],
      campaign_range_start: "",
      campaign_range_end: "",
      save_credentials: false,
      organization_id: "",
      advertiser_id: "",
      agency_id: "",
      audience_usage:""
    },
    // We used Yup here.
    validationSchema: Yup.object().shape(
      {
        campaign_range_start: Yup.date().required(
          "Campaign Date Range is required"
        ),
        campaign_range_end: Yup.date().required(
          "Campaign Date Range is required"
        ),
        //save fields
        organization_id: Yup.string().when(["advertiser_id", "agency_id"], {
          is: (advertiser_id, agency_id) => !advertiser_id && !agency_id,
          then: Yup.string().required("One of these fields must be filled"),
        }),
        advertiser_id: Yup.string().when(["organization_id", "agency_id"], {
          is: (organization_id, agency_id) => !organization_id && !agency_id,
          then: Yup.string().required("One of these fields must be filled"),
        }),
        agency_id: Yup.string().when(["organization_id", "advertiser_id"], {
          is: (organization_id, advertiser_id) =>
            !organization_id && !advertiser_id,
          then: Yup.string().required("One of these fields must be filled"),
          audience_usage: Yup.string().required("Planned Usage is required"),
        }),
      },
      [
        //Included for validation
        ["advertiser_id", "agency_id"],
        ["organization_id", "agency_id"],
        ["organization_id", "advertiser_id"],
      ]
    ),
    onSubmit: (values) => {},
  },
};
